// Components/PDF/ContactListStyles.js
import { Font, StyleSheet } from "@react-pdf/renderer";
import OpenSansBold from "../../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import RalewayBold from "../../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";
import RalewayRegular from "../../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import theme from "../../../../../../css/Theme/Theme";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    { src: RalewayBold, fontWeight: "bold" },
    { src: RalewayRegular, fontWeight: "normal" },
  ],
});

const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
  },
  content: {
    // marginBottom: 14,
    textAlign: "left",
    fontSize: 14,
    // wrap: false,
    fontFamily: "Open Sans",
  },
  subcontent: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 14,
    padding: 0, // Remove unnecessary padding
    marginTop: 5,
    marginBottom: 5, // Ensure consistent spacing between elements
    textAlign: "justify",
    color: theme.colors.Brand1PenBlue,
    letterSpacing: 0.5,
    lineHeight: 1.5,
  },
  heading: {
    fontFamily: "Raleway",
    fontSize: 18,
    fontWeight: "bold",
    color: theme.colors.Brand1PenBlue,
    marginBottom: 3,
    // marginTop: 10,
  },

  subheading: {
    fontFamily: "Raleway",
    fontSize: 14,
    marginTop: 5,
    fontWeight: "bold",
    color: theme.colors.Brand1PenBlue,
    textDecoration: "underline",

    lineHeight: 1.5,
  },
  tradingName: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 6,
    // marginBottom: 3,
    color: theme.colors.Brand1PenBlue,
    fontFamily: "Open Sans",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: `1px solid ${theme.colors.Grey25}`,
    backgroundColor: theme.colors.GhostWhite,
    paddingBottom: 6,
    paddingTop: 6,
    marginTop: 6,
    marginBottom: 6,
    fontSize: 14,
    fontWeight: "bold",
    color: theme.colors.Black,
    fontFamily: "Open Sans",
  },
  row: {
    flexDirection: "row",
    paddingVertical: 4,
    borderBottom: "none",
    // borderBottom: "0.5px solid #e0e0e0",
  },
  cellName: { width: "40%" },
  cellEmail: { width: "40%" },
  cellPhone: { width: "20%", textAlign: "right" },
});

export default pdfStyles;
